export default {
  SEND_TO_PREVIEW: 0,
  PRINT: 1,
  OPEN: 2
};
